import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import { useSuperAdminSingleOrg } from "../../../../context/SuperAdmin/SingleOrgContext";
import { useAuthContext } from "../../../../hooks/Auth";

const HeadersSuborgsTable = () => {
  const {
    suborgSearchQuery,
    setSuborgSearchQuery,
    toggleCreateSuborgModal,
    isCreateSuborgModalOpen,
  } = useSuperAdminSingleOrg();

  const { canAccess } = useAuthContext();

  return (
    <Grid container spacing={4} display={"flex"} alignItems={"center"}>
      {/* Formulario de búsqueda */}
      <Grid item xs={6} md={6}>
        <TextField
          size="small"
          variant="outlined"
          placeholder="Ej: Colegio San José"
          value={suborgSearchQuery}
          onChange={(e) => setSuborgSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      {canAccess("create:suborganization") && (
        <Grid
          item
          xs={6}
          md={6}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"flex-end"}
        >
          <Button
            variant="contained"
            onClick={() => toggleCreateSuborgModal(true)}
            sx={{ background: "#336B87" }}
            startIcon={<PersonAddOutlinedIcon />}
            disabled={isCreateSuborgModalOpen}
          >
            Crear suborganizacion
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default HeadersSuborgsTable;
